import { loadView } from './functions';

export const AdminChildren = {
  children: [
    {
      path: '',
      name: 'Admin',
      component: loadView('Admin/Dashboard'),
      ...userMeta(),
    },
    {
      path: 'dashboard',
      name: 'Dashboard',
      component: loadView('Admin/Dashboard'),
      ...userMeta(),
    },
    {
      path: 'users',
      name: 'Users',
      component: loadView('Admin/Users/View'),
      ...userMeta(),
    },
    {
      path: 'user/:id/edit',
      name: 'User Details Edit',
      component: loadView('Admin/Users/Edit'),
      ...userMeta(),
    },
    {
      path: 'categories',
      name: 'Categories',
      component: loadView('Admin/Categories/View'),
      ...userMeta(),
    },
    {
      path: 'category/:id',
      name: 'Category Details',
      component: loadView('Admin/Categories/Details'),
      ...userMeta(),
    },
    {
      path: 'category/:id/edit',
      name: 'Category Edit',
      component: loadView('Admin/Categories/Edit'),
      ...userMeta(),
    },
    {
      path: 'locations',
      name: 'Locations',
      component: loadView('Admin/Locations/View'),
      ...userMeta(),
    },
    {
      path: 'location/:id',
      name: 'Location Details',
      component: loadView('Admin/Locations/Details'),
      ...userMeta(),
    },
    {
      path: 'location/:id/edit',
      name: 'Location Edit',
      component: loadView('Admin/Locations/Edit'),
      ...userMeta(),
    },
  ],
};

function userMeta() {
  return {
    meta: { authorize: ['admin'] },
  };
}
